import {
  EmailIcon,
  EmailShareButton,
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
} from "next-share";
import FbLightIcon from "@/assets/icons/purple/fb.svg";
import LiLightIcon from "@/assets/icons/purple/li.svg";
import XLightIcon from "@/assets/icons/purple/x.svg";
import EmailLightIcon from "@/assets/icons/purple/email.svg";

export default function BlogShare({
  style: { title, color, line },
  page,
  url,
  content,
}) {
  return (
    <div className="flex flex-col items-center">
      <p className={`text-xl ${color ?? "text-white-light"}`}>{title}</p>
      <div
        className={`${line ?? "bg-white"} h-[81px] w-[1px] hidden sm:block`}
      />
      <div className="flex flex-row sm:flex-col items-center pt-3 px-5 flex-wrap sm:px-0 justify-center">
        <FacebookShareButton
          url={`https://www.lawrenceharvey.com/${page}/${url}`}
          quote={content}
        >
          <div className={`${line ? "opacity-50" : ""}`}>
            <FbLightIcon />
          </div>
        </FacebookShareButton>
        <LinkedinShareButton
          url={`https://www.lawrenceharvey.com/${page}/${url}`}
        >
          <div className={`${line ? "opacity-50" : ""}`}>
            <LiLightIcon />
          </div>
        </LinkedinShareButton>
        <TwitterShareButton
          url={`https://www.lawrenceharvey.com/${page}/${url}`}
          title={content}
        >
          <div className={`${line ? "opacity-50" : ""}`}>
            <XLightIcon />
          </div>
        </TwitterShareButton>
        <EmailShareButton
          url={`https://www.lawrenceharvey.com/${page}/${url}`}
          title={content}
        >
          <div
            className={`${line ? "opacity-50" : ""} w-[73px] h-[73px] flex items-center justify-center`}
          >
            <EmailLightIcon />
          </div>
        </EmailShareButton>
      </div>
    </div>
  );
}
